export default __webpack_public_path__ + "relation-text-extract5b88a1.png";